export default __webpack_public_path__ + "static/media/external-link-black.6b999912.svg";